export const LOGIN = '/login';
export const SIGN_UP = '/signup';
